export default __webpack_public_path__ + "static/img-corvina-500x325-055c97a59cf9e1338d17fc8caa502ac1.png";